// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/ProximaNova-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/ProximaNova-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/ProximaNova-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/ProximaNova-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts//ProximaNova-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/ProximaNova-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 120%;
}

body {
  font-family: ProximaNova-Regular, sans-serif;
  color: #6b6b6b;
  background-color: #f6f6f6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 20em;
}

@font-face {
  font-family: "ProximaNova-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-style: normal;
}

@font-face {
  font-family: "ProximaNova-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-style: normal;
}

@font-face {
  font-family: "ProximaNova-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-style: normal;
}

img,
svg,
video {
  display: block;
  max-width: 100%;
  width: 100%;
}

a {
  font-family: "ProximaNova-Semibold";
  text-decoration: none;
  color: #4586d2;
}

a:visited {
  color: #4586d2;
}

table,
tbody,
thead,
tr,
th,
td {
  border: 0;
  outline: 0;
  vertical-align: baseline;
}

@media screen and (max-width: 1920px) {
  html {
    font-size: 110%;
  }
}

@media screen and (max-width: 1440px) {
  html {
    font-size: 100%;
  }
}

@media screen and (max-width: 1280px) {
  html {
    font-size: 95%;
  }
}

@media screen and (max-width: 1024px) {
  html {
    font-size: 90%;
  }
}

@media screen and (max-width: 768px) {
  html {
    font-size: 85%;
  }
}

@media screen and (max-width: 480px) {
  html {
    font-size: 80%;
  }
}

.react-datepicker-wrapper,
.react-datepicker__input-container {
  display: block;
}

.react-datepicker {
  font-family: ProximaNova-Regular, sans-serif;
  color: #353535;
  border-radius: 0.25em;
  border: 0.063em solid #ebebeb;
  box-shadow: 0 0.125em 0.25em 0 rgba(36, 66, 99, 0.1);
}

.react-datepicker__header {
  border-bottom: 0.063em solid #e9e9e9;
  background-color: transparent;
  padding-top: 0;
}

.react-datepicker__current-month {
  font-family: ProximaNova-Semibold, sans-serif;
  background-color: #4586d2;
  color: white;
  text-transform: uppercase;
  border-radius: 0.313em;
  line-height: 2.5em;
}

.react-datepicker__month {
  font-size: 0.875em;
  font-family: ProximaNova-Semibold, sans-serif;
}

.react-datepicker__month-container {
  padding: 1em;
}

.react-datepicker__day--selected {
  border-radius: 0.357em;
  background-color: #4586d2;
}

.react-datepicker__day-names {
  text-transform: uppercase;
}

.react-datepicker__navigation {
  top: 2em;
}

.react-datepicker__navigation--previous {
  border-right-color: white;
  left: 1.5em;
}

.react-datepicker__navigation--next {
  border-left-color: white;
  right: 1.5em;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {
  border-bottom-color: #ffffff;
}

.react-datepicker-popper[data-placement^="bottom"]
  .react-datepicker__triangle::before {
  border-bottom-color: #ebebeb;
}
`, "",{"version":3,"sources":["webpack://./source/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,4CAAyC;EACzC,2DAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,4CAA0C;EAC1C,2DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,4CAAuC;EACvC,2DAAsD;EACtD,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-size: 120%;\n}\n\nbody {\n  font-family: ProximaNova-Regular, sans-serif;\n  color: #6b6b6b;\n  background-color: #f6f6f6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  min-width: 20em;\n}\n\n@font-face {\n  font-family: \"ProximaNova-Regular\";\n  src: url(\"fonts/ProximaNova-Regular.eot\");\n  src: url(\"fonts/ProximaNova-Regular.woff\") format(\"woff\");\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"ProximaNova-Semibold\";\n  src: url(\"fonts/ProximaNova-Semibold.eot\");\n  src: url(\"fonts/ProximaNova-Semibold.woff\") format(\"woff\");\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"ProximaNova-Bold\";\n  src: url(\"fonts//ProximaNova-Bold.eot\");\n  src: url(\"fonts/ProximaNova-Bold.woff\") format(\"woff\");\n  font-style: normal;\n}\n\nimg,\nsvg,\nvideo {\n  display: block;\n  max-width: 100%;\n  width: 100%;\n}\n\na {\n  font-family: \"ProximaNova-Semibold\";\n  text-decoration: none;\n  color: #4586d2;\n}\n\na:visited {\n  color: #4586d2;\n}\n\ntable,\ntbody,\nthead,\ntr,\nth,\ntd {\n  border: 0;\n  outline: 0;\n  vertical-align: baseline;\n}\n\n@media screen and (max-width: 1920px) {\n  html {\n    font-size: 110%;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  html {\n    font-size: 100%;\n  }\n}\n\n@media screen and (max-width: 1280px) {\n  html {\n    font-size: 95%;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  html {\n    font-size: 90%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  html {\n    font-size: 85%;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  html {\n    font-size: 80%;\n  }\n}\n\n.react-datepicker-wrapper,\n.react-datepicker__input-container {\n  display: block;\n}\n\n.react-datepicker {\n  font-family: ProximaNova-Regular, sans-serif;\n  color: #353535;\n  border-radius: 0.25em;\n  border: 0.063em solid #ebebeb;\n  box-shadow: 0 0.125em 0.25em 0 rgba(36, 66, 99, 0.1);\n}\n\n.react-datepicker__header {\n  border-bottom: 0.063em solid #e9e9e9;\n  background-color: transparent;\n  padding-top: 0;\n}\n\n.react-datepicker__current-month {\n  font-family: ProximaNova-Semibold, sans-serif;\n  background-color: #4586d2;\n  color: white;\n  text-transform: uppercase;\n  border-radius: 0.313em;\n  line-height: 2.5em;\n}\n\n.react-datepicker__month {\n  font-size: 0.875em;\n  font-family: ProximaNova-Semibold, sans-serif;\n}\n\n.react-datepicker__month-container {\n  padding: 1em;\n}\n\n.react-datepicker__day--selected {\n  border-radius: 0.357em;\n  background-color: #4586d2;\n}\n\n.react-datepicker__day-names {\n  text-transform: uppercase;\n}\n\n.react-datepicker__navigation {\n  top: 2em;\n}\n\n.react-datepicker__navigation--previous {\n  border-right-color: white;\n  left: 1.5em;\n}\n\n.react-datepicker__navigation--next {\n  border-left-color: white;\n  right: 1.5em;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] .react-datepicker__triangle {\n  border-bottom-color: #ffffff;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"]\n  .react-datepicker__triangle::before {\n  border-bottom-color: #ebebeb;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
